import { Account } from '@syf-api-library/credit-accounts'
import { PSCC } from 'const/account/products'

/**
 * Conditions to satisfy are below:
 * Lead account is Paysol - This ensures they are coming from Consumer Center Login
 * No RC account along side of it
 * Can be one or more Paysol accounts
 *
 */
const hasPSCCAccounts = (accounts: Account[]) => {
  return accounts.every((account) => account.product.lineOfBusiness === PSCC)
}

export default hasPSCCAccounts
